import type { Action } from 'redux';
import type { IAdLink } from '../../../../../../shared/types';
import NotificationActions from '../../../../main/actions/NotificationActions';
import { AdLinkEditorService } from '../../../../main/services/AdLinkEditorService/AdLinkEditorService';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const FetchAdLink = new ReduxAsyncAction<'FETCH_AD_LINK', string, IAdLink>('FETCH_AD_LINK');

FetchAdLink.registerRequest(async (adLinkId: string): Promise<IAdLink> => {
  try {
    const { data } = await dash_api.get(`/v1/linkhub/ad/${adLinkId}`);

    return AdLinkEditorService.getAdLinkPayload(data);
  } catch (error) {
    NotificationActions.showNotification('Failed to fetch ad link.', 'error');

    throw error;
  }
});

export const FETCH_AD_LINK = FetchAdLink.actionNamespaceConstants;
export const fetchAdLink = FetchAdLink.request;

export type FetchAdLinkResponseAction = Action<typeof FETCH_AD_LINK.response> & {
  data: IAdLink;
};
